

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { PatientAppointment } from '../patient-services/patient-appointment';
import { PatientRegistration } from '../patient-services/patient-registration';



export interface VisitParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Visit {
    id?: string;
    visitId?: number;
    visitDate?: Date | String;
    toDate?:Date | string;
    regId: string;
    tenantId?: string;
    branchId?: string;
    status?: string;
    appointmentId?:any;
    entryFrom?:string;
    admissionId?:number;
    emergencyFlag?:string;
    patientAppointment?:PatientAppointment;
    patientRegistration?: PatientRegistration;
    parameters?: VisitParameter[];
    links?: any;
}
export const pages = {
  GYNECOLOGY: 'gynecology',
  OBSTERITICS: 'obs',
  DENTAL: 'dental',
  PEDIATRICS : 'pediatrics', 
  GENERAL: 'general',
  IP: 'ip'
};


export abstract class VisitData {
 
  abstract list(url: string): Observable<Visit[]>;
  abstract getDashboardData(url: string): Observable<any>;
  abstract getDashboardList(url: string): Observable<any[]>;
  abstract getById(url: string,data: Visit): Observable<any>;
  abstract create(url: string,data: Visit): Observable<any>;
  abstract update(url: string,data: Visit): Observable<any>;
  abstract delete(url: string): Observable<any>;
abstract getLastVisit(url: string): Observable<any[]>;
}
